import React, { useState, useRef, useEffect } from "react";
import Sidebar from "../Sidebar";
import Layout from "../Layout";
import "../../index.css";
import { useQuery, gql, useMutation } from "@apollo/client";
import BackButton from "../CommonComponents/BackButton";
import CustomSelect from "../CommonComponents/CustomSelect";
import LabledInput from "../CommonComponents/LabledInput";

const EMPLOYEE_LIST = gql`
  query getEmployeeList($data: EmployeeFilterInput) {
    getEmployeelist(data: $data) {
      status
      message
      employee {
        id
        fullName
      }
    }
  }
`;

const UPDATE_INVENTORY = gql`
  mutation updateInventory($data: updateInventoryInput!) {
    updateInventory(data: $data) {
      status
      message
    }
  }
`;

const EditInventory = ({ editFormData, setEditForm, onRowUpdated }) => {
  const [updateInventory, { loading: updateLoading }] =
    useMutation(UPDATE_INVENTORY);
  const { loading: employeeListLoading, data: employeeList } = useQuery(
    EMPLOYEE_LIST,
    {
      variables: { data: { bookableOrEmployed: true } },
    }
  );

  const [employees, setEmployees] = useState([]);
  const [usage, setUsage] = useState(editFormData.usage || 0);
  const [employeeId, setEmployeeId] = useState(editFormData.employeeId || null);
  const [isFetched, setIsFetched] = useState(false);

  useEffect(() => {
    setEmployees(employeeList?.getEmployeelist?.employee || []);
    setIsFetched(true);
  }, [employeeList]);

  useEffect(() => {
    // keep local state in sync when editFormData changes
    setUsage(editFormData.usage || 0);
    setEmployeeId(editFormData.employeeId || null);
  }, [editFormData]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const finalDataObj = {
      id: editFormData.id,
      usage: parseInt(usage),
      employeeId: employeeId,
      printedCount: editFormData.printedCount || 0,
    };

    updateInventory({
      variables: { data: finalDataObj },
    })
      .then((res) => {
        if (res.data?.updateInventory?.status === "SUCCESS") {
          // provide updated row to parent so it can patch local list without reloading
          const updatedRow = {
            ...editFormData,
            usage: finalDataObj.usage,
            employeeId: finalDataObj.employeeId,
          };
          if (onRowUpdated) onRowUpdated(updatedRow);
          else window.location = "/admin/inventory-table"; // fallback
        } else {
          console.error("Update failed", res.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      <div className="min-h-screen flex">
        <Sidebar />
        <Layout>
          {isFetched && !employeeListLoading && (
            <div className="flex flex-col py-3 px-2 space-y-5">
              <BackButton onClick={() => setEditForm(false)} />
              <h3 className="text-[#FBB033] font-be-jost-pro font-bold text-2xl">
                Edit Inventory
              </h3>
              <div className="w-full flex flex-col space-y-8">
                <CustomSelect
                  label="Professional*"
                  placeholder="Select professional"
                  value={employeeId}
                  optionLabelKey="fullName"
                  optionValueKey="id"
                  onChange={(e) => setEmployeeId(e.target.value)}
                  options={employees}
                  required={true}
                  inline
                  showReset
                />
                <LabledInput
                  required={true}
                  type="number"
                  value={usage}
                  onChange={(e) => setUsage(e.target.value)}
                  label={"Usage*"}
                  placeholder={"Type usage here..."}
                />
                <div className="flex items-center justify-center">
                  <button
                    className="bg-[#FBB034] text-[#202125] py-2 px-6 rounded-md font-poppins text-sm font-bold"
                    onClick={handleSubmit}
                    disabled={updateLoading}
                  >
                    {updateLoading ? "Updating..." : "Update Inventory"}
                  </button>
                </div>
              </div>
            </div>
          )}
        </Layout>
      </div>
    </>
  );
};

export default EditInventory;
